module.exports = __webpack_public_path__ + "media/newstyle/images/medium-shot-excited-woman-with-laptop-1cf61a0bc75b5cfdf7f6766dfe46c0da.png";